// Romanian editorial layer for the journeys used most often by players.
// Product and federation names remain unchanged: Padbol, Padbol Match and FIPA.
const ROMANIAN_LOCALE_OVERRIDES = {
  general: {
    confirm: 'Confirmă', cancel: 'Anulează', close: 'Închide', save: 'Salvează',
    edit: 'Editează', delete: 'Șterge', back: 'Înapoi', continue: 'Continuă',
    accept: 'Acceptă', cookiesAccept: 'Acceptă', goHome: 'Mergi la pagina principală',
    goLogin: 'Autentifică-te', somethingWentWrong: 'A apărut o problemă',
  },
  torneos: {
    crear: 'Creează un turneu', inscribirse: 'Înscrie-te', detalle: 'Turneu',
    filtroEstado: { inscripcion_abierta: 'Înscrieri deschise', proximo: 'În curând' },
    tipo: {
      eliminacion: 'Eliminare directă', knockout: 'Eliminare directă',
      eliminatoria: 'Eliminare directă',
    },
    listado: {
      subtitleDefault: 'Alege un turneu pentru a vedea detaliile, a te înscrie și a forma sau a te alătura unei echipe.',
      subtitleSedeOnly: 'Sunt afișate doar turneele acestui club.',
      subtitleNear: 'Sunt prioritizate turneele din clubul cel mai apropiat sau din ultimul club folosit.',
      geoDetecting: 'Îți detectăm locația. Dacă nu este posibil, folosim ultima locație salvată sau afișăm toate turneele.',
      lastVenue: 'Ultimul tău club', changeVenue: 'Schimbă orașul / clubul',
      estadoLabel: 'Starea turneului', estadoAria: 'Starea turneului',
      searchPlaceholder: 'Caută turnee, cluburi, orașe sau țări…',
      emptySede: 'Momentan nu există turnee în acest club.',
      emptyEstado: 'Nu există turnee cu starea selectată.', seeAllEstados: 'Vezi toate stările',
      clubDefault: 'Club', sinNombre: 'Fără nume',
      tabActivos: 'În curând / În desfășurare', tabFinalizados: 'Finalizate',
      vistaTabsAria: 'Vizualizare turnee', participants: '{{count}} participanți',
      participants_one: '{{count}} participant',
      emptyFinalizados: 'Nu există încă turnee finalizate.',
      datesRange: '{{start}} – {{end}}',
    },
    vista: {
      tabFixture: 'PROGRAM', tabLlave: 'TABLOU', colEquipo: 'ECHIPĂ',
      pendiente: 'În așteptare', cerrar: 'Închide', cargarResultado: 'Introdu rezultatul',
      realizarSorteo: 'Efectuează tragerea la sorți',
      detallePartido: 'Rezultatul meciului',
      estado: {
        planificacion: 'În curând', proximo: 'În curând',
        inscripcion_abierta: 'Înscrieri deschise', abierto: 'Înscrieri deschise',
      },
      genero: { masculino: 'Masculin', femenino: 'Feminin', mixto: 'Mixt' },
      categoriaEdad: { open: 'Open', master_40: 'Master 40', master_50: 'Master 50' },
      categoriaNivel: {
        Libre: 'Open (toate categoriile)', Femenino: 'Feminin', Mixto: 'Mixt',
      },
    },
    admin: {
      generarFixture: 'Generează programul', fixtureGenerado: 'Program generat',
      errorGenerarFixture: 'Programul nu a putut fi generat',
    },
  },
  perfil: {
    titulo: 'Profilul meu', nivel: 'Nivel de joc',
    noProfileYet: 'Nu ai încă un profil de jucător.',
    playerData: 'Datele jucătorului', usualPartner: 'Partener obișnuit',
    lastPartner: 'Ultimul partener', lookingForPartnerYes: 'Da · vizibil în clubul tău',
    searchVenuePlaceholder: 'Caută clubul tău (min. 2 litere)…',
    mainSport: 'Sport principal', activeTab: 'Filă activă',
    mostFrequentVenue: 'Club frecventat cel mai des',
    noUpcomingBookings: 'Nu ai rezervări viitoare',
    firstName: 'Prenume', lastName: 'Nume',
    partnerHabitual: 'Partener obișnuit', regularPartner: 'Partener obișnuit',
    viewPublicProfile: 'Vezi profilul meu public',
    flow: {
      completeForTournament: 'Completează-ți profilul pentru a participa la turnee',
      completeToContinue: 'Completează-ți profilul, inclusiv numărul WhatsApp, pentru a continua.',
      cropFailed: 'Imaginea nu a putut fi decupată.',
      chooseImageFile: 'Alege un fișier imagine.',
      imageOver2mb: 'Imaginea depășește 2 MB.',
      uploadPhotoFailed: 'Fotografia nu a putut fi încărcată: {{message}}',
      playerRecordNotFound: 'Profilul tău de jucător nu a putut fi găsit.',
      selectLaterality: 'Selectează mâna dominantă.',
      registrationFailed: 'Contul nu a putut fi creat.',
      cancelFailed: 'Anularea nu a putut fi efectuată',
      cityPlaceholder: 'Ex.: București, Cluj-Napoca, Madrid…',
      searchUsualClub: 'Caută clubul obișnuit',
      bringHistoryTitle: 'Adaugă istoricul tău de joc. Îl vom recunoaște.',
      changeProfilePhoto: 'Schimbă fotografia de profil',
      saving: 'Se salvează…', savePhoto: 'Salvează fotografia',
      saveReturnTournament: 'Salvează și revino la turneu',
      showLess: 'Arată mai puțin', showAll: 'Arată tot',
      attended: '✅ A participat', notAttended: '❌ Nu a participat',
      attendancePending: '— În așteptare',
      keepBooking: 'Nu, păstrează rezervarea',
      searchPlayer: 'Caută după nume sau alias…',
    },
  },
  auth: {
    access: 'Acces', login: 'Autentificare', loginTitle: 'Autentificare',
    register: 'Înregistrează-te', cerrar_sesion: 'Deconectare',
    completeProfile: 'Completează profilul', goToLogin: 'Mergi la autentificare',
    signIn: 'Autentifică-te', orDivider: '— sau —',
    firstName: 'Prenume', lastName: 'Nume',
    placeholderFirstName: 'Ex.: Andrei', placeholderLastName: 'Ex.: Popescu',
    handedness: 'Mâna dominantă', handednessRight: 'Dreptaci',
    handednessLeft: 'Stângaci', handednessAmbi: 'Ambidextru',
    levelCategory: 'Nivel / categorie', acceptTermsPrefix: 'Accept', andThe: 'și',
    acceptTerms: 'Trebuie să acceptați Termenii și condițiile și să confirmați că ați citit Politica de confidențialitate.',
    oauthLegalRecordingTitle: 'Nu am putut verifica acceptarea',
    oauthLegalRecordingError: 'Sesiunea a început, dar nu am putut salva o dovadă verificabilă a documentelor juridice. Nu vom continua până când aceasta nu este înregistrată corect.',
    legalGateTitle: 'Am actualizat informațiile juridice',
    legalGateBody: 'Înainte de a continua, consultați documentele actuale. Vom înregistra versiunea acceptată și ora serverului pentru a păstra o dovadă verificabilă.',
    legalGateConfirmation: 'Accept Termenii și condițiile actuale și confirm că am citit Politica de confidențialitate.',
    legalGateAccept: 'Acceptă și continuă',
    legalGateCheckError: 'Nu am putut verifica starea acceptării. Verificați conexiunea și încercați din nou.',
    legalGateSaveError: 'Nu am putut înregistra acceptarea în mod verificabil. Încercați din nou.',
  },
  nav: {
    perfil: 'Profil', jugar: 'Joacă', competir: 'Competiții', logout: 'Deconectare',
    backToHub: 'Înapoi', myProfile: 'Profilul meu', adminPanel: 'Panou de administrare',
    admin: { validaciones: 'Validări', mi_sede: 'Clubul meu' },
  },
  jugar: {
    titulo: 'Hai să jucăm!', reservar: 'Rezervă un teren',
    reservarBody: 'Am echipa completă și vreau să rezerv un teren.',
    buscar: 'Caută un meci', buscarBody: 'Vreau să mă alătur unui meci existent.',
    clase: 'Ia o lecție', claseBody: 'Antrenează-te cu un instructor din clubul tău.',
    armar: 'Organizează un meci', armarBody: 'Vreau să creez un meci și să adaug jucători.',
  },
  competir: {
    titulo: 'Competiții', howTitle: 'Cum vrei să concurezi?',
    howSubtitle: 'Participă la turnee oficiale sau consultă clasamentul jucătorilor.',
    torneosCardBody: 'Înscrie-te, formează o echipă și urmărește programul.',
  },
  reservas: {
    titulo: 'Rezervă un teren', header: 'Rezervare', heroTitle: 'Rezervă-ți terenul',
    heroSubtitle: 'Alege clubul, terenul și ora preferată', sedes: 'Cluburi',
    wherePlay: 'Unde vrei să joci?', nearestVenue: 'Clubul cel mai apropiat de tine',
    venueDefault: 'Club', perSlot: '/ interval', book: 'Rezervă',
    loadingVenue: 'Se încarcă informațiile clubului…',
    noPricing: 'Acest club nu are prețuri configurate pentru nicio durată. Contactează clubul.',
    onlyDuration: 'Aceasta este singura durată disponibilă la acest club.',
    availableTimes: 'Ore disponibile', slotFree: 'liber', slotsFree: 'libere',
    chooseCourt: 'Alege terenul:', court: 'Teren', labelVenue: 'Club:',
    labelCourt: 'Teren:', labelPlayer: 'Jucător:', labelSlot: 'Interval:',
    serviceFee: 'Taxă de serviciu Padbol Match (0%):',
    noServiceFeeVenue: 'Comision Padbol Match pentru jucător: 0%.',
    payAtVenueTitle: 'Plată la club',
    payAtVenueBody: 'Acest club acceptă plata la fața locului. Rezervarea rămâne în așteptare până când plătești la club.',
    extrasTitle: 'Mai dorești ceva pentru repriza a treia? 🍕',
    stripeNotConnected: 'Acest club nu a finalizat conectarea la Stripe. Alege alt club sau contactează clubul.',
    goToBookings: 'Mergi la rezervările mele', loadVenuesError: 'Cluburile nu au putut fi încărcate.',
    invalidVenuesResponse: 'Răspuns nevalid la încărcarea cluburilor.',
    networkVenuesError: 'Eroare de rețea la încărcarea cluburilor.',
    searchCourtsError: 'Eroare la căutarea terenurilor disponibile',
    payAtVenueAlert: 'Acest club acceptă plata la fața locului. Prezintă rezervarea când ajungi.',
    paidNotRegistered: 'Plata a fost confirmată, dar rezervarea nu a putut fi înregistrată. Contactează clubul.',
    morningRate: '🌅 Tarif de dimineață', eveningRate: '🌆 Tarif de după-amiază / seară',
    cancelModalMessage: 'Vei părăsi procesul, iar intervalul va fi eliberat dacă fusese reținut.',
    bookOnBehalf: 'Rezervare pentru:', venueLabel: 'Club',
    searchVenuePlaceholder: 'Caută un club sau un oraș…',
    nearestFiveVenues: 'Se afișează cele mai apropiate 5 cluburi.',
    fiveVenuesEnableGeo: 'Sunt afișate 5 cluburi. Activează locația pentru a le vedea pe cele mai apropiate.',
    askVenueSports: 'Întreabă clubul', viewCourts: 'Vezi terenurile →',
    courtsAvailableTitle: 'Terenuri disponibile', bookCourt: 'Rezervă terenul',
    loadingVenuesList: 'Se încarcă cluburile…', noVenuesAvailable: 'Nu există cluburi disponibile.',
    noVenuesForSport: 'Nu există cluburi disponibile pentru acest sport în zona ta.',
    verSede: 'Vezi clubul', clearVenue: 'Elimină clubul',
    platformFee: 'Taxă de platformă ({{pct}}%):', allSports: 'Toate sporturile',
    sportNotInZone: 'Indisponibil în zona ta',
    checkingSportsInZone: 'Se verifică sporturile disponibile în zona ta…',
    noCourtsSportInCountry: 'Nu există terenuri de {{deporte}} disponibile în {{pais}}. Poți căuta în altă țară folosind selectorul de mai sus.',
    changeCountry: 'Schimbă țara', dynamicPrice: '⚡ Preț dinamic',
    paymentDescription: 'Terenul {{num}} — {{venue}}',
  },
  perfilPublico: {
    loading: 'Se încarcă…', back: '← Înapoi',
    notFound: 'Jucătorul nu a fost găsit', playerFallback: 'Jucător',
    shareProfile: 'Distribuie profilul', myQr: 'Codul meu QR',
    statsTitle: 'Statistici', tournamentsPlayed: 'Turnee jucate',
    tournamentsWon: 'Turnee câștigate', matchesPlayed: 'Meciuri jucate',
    matchesWon: 'Meciuri câștigate', sportsTitle: 'Sporturi practicate',
    recentTournamentsTitle: 'Turnee recente',
    noRecentTournaments: 'Nu există încă turnee recente.',
    badgeWinner: 'Campion', badgeSecond: 'Locul 2', badgeThird: 'Locul 3',
    badgeParticipant: 'Locul {{pos}}', badgeParticipantGeneric: 'Participant',
    additionalInfo: 'Informații', usualClub: 'Club obișnuit',
    usualPartner: 'Partener obișnuit:', lastPartner: 'Ultimul partener:',
    category: 'Categorie', laterality: 'Mâna dominantă', federated: 'Legitimat',
    undefined: 'Nespecificat', yes: 'Da', no: 'Nu',
    pendingValidation: '⏳ în așteptare',
    pendingValidationTitle: 'Validare în așteptare',
    seeAllReviews: 'Vezi toate', allReviewsTitle: 'Toate recenziile',
    close: 'Închide',
  },
  armarPartido: {
    titleVenueAndSlot: 'Club și interval', titleSportAndVenue: 'Sport și club',
    subtitleVenueDaySlot: 'Alege clubul, ziua și intervalul pentru meciul tău.',
    subtitleSportVenueDaySlot: 'Alege sportul și clubul, apoi ziua și intervalul.',
    publicarPartido: 'Publici acest meci în „Caută un meci”?',
    publicarPartidoDesc: 'Dacă activezi opțiunea, alți jucători pot solicita să participe. Altfel, rămâne doar rezervarea confirmată.',
  },
  checkin: {
    escanear: 'Arată codul QR pentru check-in', invalido: 'Cod QR nevalid',
    reiniciar: 'Scanează alt cod QR', tuQr: 'Codul tău QR pentru check-in',
    descargar: 'Descarcă codul QR', verQr: 'Vezi codul QR',
    qrError: 'Codul QR nu a putut fi încărcat',
  },
  publicSite: {
    nav: {
      platform: 'Platformă', venues: 'Pentru cluburi',
      download: 'Descarcă aplicația', login: 'Autentificare',
      scoreboard: 'Tabela inteligentă',
    },
    hero: {
      claim: 'Aplicația sportivă care conectează totul',
      lead: 'Joc, administrare și comunitate. Creată împreună cu Padbol și pregătită pentru alte sporturi cu teren.',
      ctaExplore: 'Descoperă platforma', ctaVenue: 'Vreau Padbol Match în clubul meu',
      videoAria: 'Meci de Padbol pe teren',
      globe: {
        aria: 'Rețeaua globală Padbol Match conectează jucători, cluburi, meciuri, comunități, turnee, tabela inteligentă și sporturi.',
        labels: {
          venues: 'Cluburi', bookings: 'Rezervări', scoreboard: 'Tabela inteligentă',
          courts: 'Terenuri', experiences: 'Experiențe', calendar: 'Calendar competițional',
          liveResults: 'Rezultate în direct',
        },
      },
    },
    whatIs: {
      title: 'Ce este Padbol Match',
      text: 'Conectează jucătorii și cluburile. Reunește competiția, comunitatea și administrarea. Fiecare meci creează continuitate: nu este doar un instrument de rezervare, ci o relație care continuă și după joc.',
    },
    status: {
      title: 'Padbol Match se extinde către sporturi noi',
      text: 'Padbol conectează deja jocul, administrarea și comunitatea. Acum, Padel, Pickleball și Tenis urmează același parcurs.',
      items: {
        active: {
          title: 'Padbol, baza activă',
          text: 'Autentificarea, profilurile, rezervările, meciurile deschise, turneele, clasamentul, comunitatea, fotografiile și videoclipurile sunt deja conectate într-o singură platformă.',
        },
        rollingOut: {
          title: 'Sporturi noi, același parcurs',
          text: 'Padel, Pickleball și Tenis sunt integrate treptat în experiența de joc, administrare și comunitate Padbol Match.',
        },
        next: {
          title: 'Sponsorizările și publicitatea sunt active',
          text: 'Fiecare club își poate administra deja spațiile de sponsorizare și publicitate. Padbol Match Shop continuă ca proiect-pilot pentru produse și beneficii locale.',
        },
      },
    },
    playerPath: {
      text: 'Găsește unde, când și cu cine să joci. Rezervă, concurează și construiește-ți istoricul în cadrul comunității.',
      items: {
        find: { title: 'Găsește meciuri', text: 'Descoperă meciuri în apropiere și noi ocazii de a juca.' },
        book: { title: 'Rezervă', text: 'Rezervă intervalul dorit la clubul tău.' },
        compete: { title: 'Concurează', text: 'Turnee, echipe și rezultate.' },
        create: { title: 'Creează un meci', text: 'Stabilește clubul, ora și nivelul pentru a invita jucători.' },
        join: { title: 'Meciuri deschise', text: 'Solicită un loc, completează echipele și confirmă participarea.' },
        evolve: { title: 'Urmărește-ți progresul', text: 'Istoric, clasament și evoluție în profilul tău.' },
      },
      tapNext: 'Glisează pentru a descoperi fiecare funcție',
    },
    playerRecord: {
      kicker: 'JOCUL TĂU NU ÎNCEPE DE LA ZERO. ÎL RECUNOAȘTEM.',
      visualTagline: 'ISTORICUL TĂU. PROGRESUL TĂU. ALEGEREA TA.',
      title: 'Dacă ai jucat, ai concurat și ți-ai construit deja un istoric, acesta contează. Nu trebuie să lași în urmă parcursul tău pentru a intra în Padbol Match.',
      lead: 'Trimite-ne rezultatele, turneele, clasamentul, statisticile și realizările anterioare. Le verificăm și le adăugăm, astfel încât profilul să reflecte jucătorul care ești deja.',
      copy: 'Datele tale îți aparțin.',
      ownershipStrong: 'Îți poți lua oricând întregul istoric sportiv.',
      ownership: 'Informații care pot fi recunoscute în istoricul tău sportiv',
    },
    venuePath: {
      title: 'Pentru cluburi și organizații',
      text: 'O singură soluție pentru administrarea terenurilor, programelor, rezervărilor și comunităților din Padbol, Padel, Pickleball și Tenis.',
      items: {
        bookings: { title: 'Rezervări', text: 'Terenuri, programe și prețuri.' },
        players: { title: 'Jucători', text: 'Comunitatea activă a clubului.' },
        scoreboard: { title: 'Tabela inteligentă', text: 'Înregistrează meciul în direct și conectează-l la activitatea clubului.' },
        reports: { title: 'Administrare', text: 'Rapoarte și control operațional.' },
        occupy: { title: 'Ocupare reală', text: 'Meciuri deschise și rezervări care ocupă terenurile și intervalele libere.' },
        activate: { title: 'Activează jucătorii', text: 'Comunitatea clubului găsește parteneri de joc și revine.' },
        continuity: { title: 'Continuitate', text: 'Fiecare rezervare, lecție, turneu și meci întărește relația cu jucătorul.' },
      },
    },
    continuity: {
      title: 'Înainte, în timpul și după joc',
      text: 'Fiecare meci poate deveni istoric, competiție, progres și un nou motiv de a reveni. Meciurile deschise, rezultatele, clasamentul, PadCoins, abonamentele și comunitatea se susțin reciproc.',
      items: {
        matches: { title: 'Meciuri', text: 'Creează, completează și confirmă.' },
        tournaments: { title: 'Turnee', text: 'Competiție cu program clar.' },
        scoreboard: { title: 'Tabela inteligentă', text: 'Rezultate în direct.' },
        memberships: { title: 'Abonamente', text: 'O legătură permanentă cu clubul.' },
        openMatches: { title: 'Meciuri deschise', text: 'Poarta de intrare în joc.' },
        results: { title: 'Rezultate', text: 'Fiecare meci rămâne înregistrat.' },
      },
    },
    expansion: {
      title: 'Mai multe oportunități pentru clubul tău',
      text: 'Transformă activitatea de pe teren în relații comerciale, campanii și beneficii pentru comunitate.',
      items: {
        sponsor: {
          title: 'Sponsori',
          text: 'Relații de durată între mărci și activitatea sportivă reală.',
        },
        ads: {
          title: 'Publicitate',
          text: 'Campanii afișate în spații și momente cu atenție ridicată.',
        },
        eshop: {
          title: 'Magazin online',
          text: 'Produse și beneficii asociate clubului.',
        },
      },
      note: 'Sponsorizările și publicitatea sunt deja administrate de fiecare club. Padbol Match Shop continuă ca proiect-pilot.',
    },
    about: {
      kicker: '18 ani de dezvoltare a Padbol',
      title: 'Despre noi',
      text: 'De 18 ani dezvoltăm Padbol și ducem sportul în lume. Fiecare teren, eveniment și comunitate ne-a arătat că dezvoltarea are nevoie de instrumente care să țină pasul.',
      detail: 'De aceea am creat Padbol Match: propria noastră aplicație, care conectează jocul, administrarea și comunitatea într-un singur parcurs. Începe cu Padbol și se extinde către Padel, Pickleball și Tenis, astfel încât mai multe sporturi cu teren să poată crește pe aceeași bază.',
      founder: {
        padbolRole: 'Creatorul Padbol',
        federationRole: 'Președintele Federației Internaționale de Padbol',
        matchRole: 'Fondatorul Padbol Match',
        quote: 'Experiența și instrumentele create pentru Padbol reprezintă acum baza pentru extinderea platformei către alte sporturi cu teren — precum Tenis, Padel și Pickleball — și pentru integrarea unor sporturi noi în funcție de nevoile fiecărei comunități, fără a pierde spiritul în care s-a născut Padbol Match.',
      },
      playersNote: 'O platformă născută din experiența reală a celor care dau viață sporturilor cu teren.',
      cta: 'Vezi cum funcționează',
    },
    download: {
      title: 'Descarcă aplicația', text: 'Folosește Padbol Match direct pe telefon.',
      storeSoon: 'În curând în magazinele de aplicații',
      login: 'Autentifică-te în Padbol Match',
      webApp: 'Preferi aplicația web? Deschide-o pe computer.',
    },
    contact: {
      title: 'Începe chiar azi', text: 'Adaugă-ți clubul sau începe să joci.',
      venue: 'Vreau Padbol Match în clubul meu', login: 'Autentificare',
    },
    footer: {
      tagline: 'Joc, comunitate și administrare.',
      platform: 'Platformă', venues: 'Pentru cluburi',
      download: 'Descarcă aplicația', contact: 'Contactează-ne',
      scoreboard: 'Tabela inteligentă',
      contactHelp: 'Ai nevoie de ajutor? Contactează-ne',
    },
    paths: { aria: 'Parcursuri' },
    venueAdmin: {
      eyebrow: 'Administrarea clubului',
      title: 'Administrează-ți clubul, pas cu pas',
      text: 'Descoperă întregul flux operațional înainte de a te alătura. Fiecare modul are un rol clar și o configurare ghidată.',
      openDetail: 'Vezi pașii', close: 'Închide detaliile',
      next: {
        title: 'Adaugă-ți clubul în Padbol Match',
        text: 'Descoperă instrumentele și modul în care îți poți adăuga clubul în Padbol Match. Când ești gata, poți deschide aplicația.',
        apply: 'Adaugă clubul meu',
      },
      items: {
        setup: {
          title: 'Configurează-ți clubul',
          detail: 'Creează profilul operațional al clubului, astfel încât jucătorii și echipa ta să folosească aceleași informații.',
          result: 'Rezultat: un club pregătit să publice disponibilitatea și să primească rezervări.',
        },
        bookings: {
          title: 'Administrează rezervările',
          detail: 'Organizează disponibilitatea terenurilor și urmărește fiecare rezervare, de la solicitare până la încheiere.',
          result: 'Rezultat: rezervarea este taxată când meciul complet este confirmat, conform regulilor clubului.',
        },
        players: {
          title: 'Activează jucătorii',
          detail: 'Transformă solicitările și jucătorii ocazionali într-o comunitate care revine în clubul tău.',
          result: 'Rezultat: mai multă activitate vizibilă și jucători conectați la clubul tău.',
        },
        competition: {
          title: 'Creează competiții',
          text: 'Turnee, echipe, intervale, rezultate și clasamente ale clubului.',
          detail: 'Organizează competiții cu reguli clare, de la înscriere până la rezultatele finale.',
          result: 'Rezultat: un turneu bine organizat pentru jucători, arbitri și echipa clubului.',
        },
        scoreboard: {
          title: 'Folosește tabela inteligentă',
          text: 'Pornește, urmărește, corectează și încheie rezultatele conectate la istoric.',
          detail: 'Înregistrează meciul în direct, astfel încât rezultatul să alimenteze administrarea, istoricul și competiția.',
          result: 'Rezultat: date utile pentru istoric, clasament, turnee și administrare.',
        },
        loyalty: {
          text: 'PadCoins și abonamente, atunci când sunt activate pentru clubul tău.',
          detail: 'Recompensează participarea comunității cu beneficii controlate de club, atunci când modulele sunt active.',
          result: 'Rezultat: o relație recurentă și măsurabilă cu jucătorii clubului.',
        },
      },
    },
    communityMatches: {
      title: 'Jocul începe înainte să intri pe teren',
      text: 'Padbol Match îți permite să creezi meciuri, să găsești jucători, să intri în meciuri deschise și să completezi echipele într-o singură comunitate. Cluburile câștigă activitate reală atunci când intenția de a juca este confirmată.',
      mockMeta: 'Club · Astăzi la 19:30', mockAction: 'Solicită un loc',
      mockOccupancy: 'Grad de ocupare', mockCompleteWhenFull: 'Când toate locurile sunt ocupate',
      mockSlotsComplete: 'Toate locurile sunt ocupate: rezervarea este confirmată.',
      mockReleaseNote: 'Dacă meciul nu se completează, rezervarea este eliberată cu 8 ore înainte.',
      mockFull: 'Toate locurile sunt ocupate',
      mockStatuses: {
        looking: 'Se caută {{count}} jucători', playerConfirmed: 'Un jucător confirmat',
        matchConfirmed: 'Meci confirmat',
      },
      steps: {
        create: { title: 'Creează și publică', text: 'Configurează meciul: club, oră, nivel și locuri disponibile.' },
        publish: { title: 'Găsește și solicită', text: 'Jucătorii descoperă meciul deschis și solicită să participe.' },
        join: { title: 'Completează echipele', text: 'Acceptă solicitări, ocupă locurile și comunică cu grupul.' },
        confirm: { title: 'Confirmă și joacă', text: 'Notificările și confirmările transformă intenția în activitate reală pentru club.' },
      },
    },
    smartScoreboard: {
      title: 'Tabela inteligentă: meciul în direct',
      text: 'Tabela inteligentă înregistrează deja meciul în direct și păstrează rezultatul conectat la jucători, competiții și activitatea clubului.',
      demoAria: 'Demonstrație vizuală a tabelei inteligente',
      futureAccess: {
        text: 'Acces prin recunoaștere facială și credit PadCoins chiar din momentul sosirii la club.',
        imageAlt: 'Intrare în club prin recunoaștere facială',
      },
      steps: {
        start: { title: 'Selectează jucătorii', text: 'Selectează jucătorii sau echipele și deschide tabela.' },
        live: { title: 'Urmărește în direct', text: 'Înregistrează puncte, seturi și scorul parțial pe măsură ce se desfășoară meciul.' },
        correct: { title: 'Corectează o acțiune', text: 'Ajustează un punct sau un set atunci când este necesar.' },
        close: { title: 'Încheie rezultatul pe ecran', text: 'Confirmă scorul final și păstrează datele relevante.' },
        connect: { title: 'Conectează rezultatul', text: 'Meciul alimentează istoricul, statisticile, clasamentul și turneele, atunci când este cazul.' },
      },
    },
  },
};

export default ROMANIAN_LOCALE_OVERRIDES;
